import usePrivateLink from "../../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import Footer from "../footer";
import { Link, useNavigate } from "react-router-dom";
import Nav from "../../master/NavBar";
import Header from "../../master/SideBar";
import {
  formatDate,
  ToastMain,
  SweetAlertShow,
  LoadingDiv,
} from "../../master/Master";
import {
  StaffList,
  StudentBatchList,
  studentsAttendance,
} from "../../../api/StudentsAttendance";
import { getSessions } from "../../../api/SessionsService";
import { viewlist } from "../../../api/BatchService";
import DownloadExcel from "../../master/DownloadExcel";
import "./Sm.css";

import { monthlyAttendance } from "../../../api/Staff";

import { formatToTime } from "../../master/FormatToDateTime";
import { printElement, printImg } from "../../master/Print";
import StaffLayout from "../../staffs/StaffLayout";
import { imgBaseUrl } from "../../../api/api";
import { printAttendanceReport } from "../../master/AttendancePrint";

const getCurrentMonth = () => {
  const date = new Date();
  return date.toISOString().slice(0, 7); // YYYY-MM
};
const StaffMonthAttendance = () => {
  const hasAccess = usePrivateLink();
  const [viewType, setViewType] = useState("day");
  const [totalDays, setTotalDays] = useState(0);
  const [selectedAttendance, setSelectedAttendance] = useState("present");
  const [activeTab, setActiveTab] = useState(null);
  const [batch, setBatch] = useState();
  const [error, setError] = useState();
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [selectedSession, setSelectedSession] = useState("");
  const [staffdata, setStudents] = useState([]);
  const [batchList, setBatchList] = useState([]);
  //   const [selectedMonth, setSelectedMonth] = useState(""); // "YYYY-MM"
  const [data, setData] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [allAttendance, setAllAttendance] = useState("");
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const getMinMonth = () => {
    const now = new Date();
    now.setMonth(now.getMonth() - 5);
    return now.toISOString().slice(0, 7);
  };
  const [selectedMonth, setSelectedMonth] = useState(getCurrentMonth());

  const batchliststudent = async () => {
    const addUrl = `&session_id=${selectedSession}`;
    setLoading(true);
    try {
      // console?.log("Fetching batches with status:", status);    // ✅ Debugging log
      const response = await viewlist(addUrl);
      console?.log(
        "Batchlist response",
        response?.data?.batches?.[0]?.batch_fees,
      );

      if (response?.data?.status) {
        setBatch(response?.data || []);
        console?.log("Batch fetched", response?.data?.batches);
      } else {
        setError("Failed to fetch batches?.");
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const studentBatchFetch = async () => {
    setLoading(true);
    try {
      // console.log("Fetching Students with batch_id:",);
      const response = await StudentBatchList();

      if (response.data.success) {
        setBatchList(response.data || []);
        // console.log("Students batch list in attendance fetched", response.data);
      } else {
        setError("Failed to fetch students.");
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    studentBatchFetch();
    getSession();
    staffFetch();
  }, []);

  useEffect(() => {
    if (selectedSession) {
      batchliststudent();
    }
  }, [selectedSession]);
  const getSession = async () => {
    setLoading(true);
    try {
      const response = await getSessions();
      if (response.data.status) {
        const activeSession = response?.data?.data.find(
          (session) => session.status === "1",
        );
        setSelectedSession(activeSession.id);
        setSessions(response?.data?.data);
      } else {
        setError("Failed to fetch session.");
      }
    } catch (error) {
      // ToastMain.fire({
      //     icon: "error",
      //     title:
      //         error?.response?.data?.message ||
      //         error?.response?.message ||
      //         "Something Want Wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (sessions.length > 0 && !selectedSession) {
      setSelectedSession(sessions[0].id);
    }
  }, [sessions, selectedSession]);

  const staffFetch = async () => {
    setLoading(true);
    let addUrl = `&session=${selectedSession}&month=${selectedMonth}`;

    try {
      const response = await monthlyAttendance(addUrl);

      if (response?.data?.status) {
        let fetchedData = response?.data?.data?.staffs || [];

        // Normalize so UI does not break
        const normalized = fetchedData.map((staff) => ({
          ...staff,
          staff_attendance: staff.attendances || [], // 👈 main fix
        }));

        setStudents({ data: normalized });
        console.log("✅ Normalized Students:", normalized);
      } else {
        setError("Failed to fetch students.");
      }
    } catch (error) {
      // ToastMain.fire({
      //     icon: "error",
      //     title:
      //         error?.response?.data?.message ||
      //         error?.response?.message ||
      //         "Something went wrong!",
      // });

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedMonth) {
      staffFetch();
    }
  }, [selectedMonth, selectedSession]);

  useEffect(() => {
    if (selectedMonth) {
      const [year, month] = selectedMonth.split("-").map(Number);
      setTotalDays(new Date(year, month, 0).getDate());
    }
  }, [selectedMonth]);

  const handleDownload = async () => {
    setLoading(true);

    try {
      const exportData = [];

      // 👉 STAFF FIXED COLUMNS
      const staffColumns = [
        "SN",
        "Name",
        "Reg No",
        "Mobile",
        "Type",
        "Joining Date",
      ];

      // 👉 DAYS COLUMNS (1 - totalDays)
      const dayColumns = Array.from(
        { length: totalDays },
        (_, i) => `${i + 1}`,
      );

      // 👉 FINAL COLUMN ORDER
      const columns = [...staffColumns, ...dayColumns, "Present", "Absent"];

      staffdata?.data?.forEach((staff, index) => {
        let totalPresent = 0;
        let totalAbsent = 0;

        const workingDays = JSON.parse(
          staff?.employment_info?.working_days || "[]",
        );

        // 👉 पहले empty row बनाओ
        let finalRow = {};

        // ✅ STAFF INFO FIRST
        finalRow["SN"] = index + 1;
        finalRow["Name"] = staff?.name || "";
        finalRow["Reg No"] = staff?.registration_no || "";
        finalRow["Mobile"] = staff?.mobile || "";
        finalRow["Type"] = staff?.staff_type || "";
        finalRow["Joining Date"] = staff?.employment_info?.joining_date
          ? formatDate(staff?.employment_info?.joining_date)
          : "";

        // ✅ THEN DAYS
        for (let i = 0; i < totalDays; i++) {
          const day = String(i + 1);
          const currentDate = `${selectedMonth}-${day.padStart(2, "0")}`;

          const dayAttendances =
            staff?.attendances?.filter((att) => att.date === currentDate) || [];

          const checkDate = new Date(currentDate);
          const today = new Date();

          const isFuture = checkDate > today;

          const dayName = checkDate.toLocaleString("en-US", {
            weekday: "long",
          });

          const isWorkingDay = workingDays.includes(dayName);

          let value = "";

          if (isFuture) {
            value = "-";
          } else if (dayAttendances.length > 0) {
            if (dayAttendances.some((a) => a.is_leave === "1")) {
              value = "A";
              totalAbsent++;
            } else {
              value = dayAttendances
                .map(
                  (a) =>
                    `${formatToTime(a.check_in_time)} / ${formatToTime(
                      a.check_out_time,
                    )}`,
                )
                .join(" , ");
              totalPresent++;
            }
          } else if (!isWorkingDay) {
            value = dayName === "Sunday" ? "Sun" : "No Working";
          } else {
            value = "A";
            totalAbsent++;
          }

          finalRow[day] = value || "-";
        }

        // ✅ LAST TOTALS
        finalRow["Present"] = totalPresent;
        finalRow["Absent"] = totalAbsent;

        exportData.push(finalRow);
      });

      // ✅ ORDER FIX (MOST IMPORTANT)
      const orderedData = exportData.map((row) => {
        let newRow = {};

        columns.forEach((col) => {
          newRow[col] = row[col] ?? "";
        });

        return newRow;
      });

      if (orderedData.length > 0) {
        DownloadExcel(orderedData, columns, "Staff_Attendance_Table");
      } else {
        SweetAlertShow("info", "Info", "No records found.");
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message ?? "Something went wrong",
      );
    } finally {
      setLoading(false);
    }
  };
return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row">
                  <StaffLayout />
                  <div className="col-12">
                    {/* Header */}

                    <div className="card border-0 shadow-sm mb-4">
                      <div className="card-body">
                        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center">
                          <div>
                            <h3 className="fw-bold text-primary mb-1">
                              <i className="ri-calendar-2-line me-2"></i>
                              Monthly Staff Attendance
                            </h3>

                            <p className="text-muted mb-0">
                              View monthly attendance, working hours and
                              attendance summary.
                            </p>
                          </div>

                          <div className="d-flex gap-2 mt-3 mt-lg-0">
                            {hasAccess('/staff_month_attendance/export') && (
                              <button
                                className="btn btn-success"
                                onClick={handleDownload}
                              >
                                <i className="ri-file-excel-2-line me-1"></i>
                                Export
                              </button>
                            )}

                            <button
                              className="btn btn-primary"
                              onClick={() =>
                                printAttendanceReport(
                                  staffdata.data,
                                  selectedMonth,
                                  totalDays,
                                )
                              }
                            >
                              <i className="ri-printer-line me-1"></i>
                              Print
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row g-3 mb-4">
                      <div className="col-md-4">
                        <div className="card border-0 shadow-sm">
                          <div className="card-body">
                            <small className="text-muted">Total Staff</small>

                            <h3 className="fw-bold mt-2">
                              {staffdata?.data?.length || 0}
                            </h3>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="card border-0 shadow-sm">
                          <div className="card-body">
                            <small className="text-muted">
                              Attendance Month
                            </small>

                            <h4 className="fw-bold text-primary mt-2">
                              {selectedMonth}
                            </h4>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="card border-0 shadow-sm">
                          <div className="card-body">
                            <small className="text-muted">Days</small>

                            <h3 className="fw-bold text-warning mt-2">
                              {totalDays}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card border-0 shadow-sm mb-4">
                      <div className="card-body">
                        <div className="row align-items-end g-3">
                          <div className="col-lg-3">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="month"
                                className="form-control"
                                value={selectedMonth}
                                onChange={(e) =>
                                  setSelectedMonth(e.target.value)
                                }
                                min={getMinMonth()}
                                max={getCurrentMonth()}
                              />

                              <label>Attendance Month</label>
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <button
                              className="btn btn-primary w-100"
                              onClick={staffFetch}
                            >
                              <i className="ri-refresh-line me-1"></i>
                              Refresh Report
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card p-4 mb-4" id="print">
                      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap mb-5">
                        <strong className="fw-bold fs-5">
                          Staff Attendance List
                        </strong>
                      </div>

                      <div className="table-responsive ">
                        <table
                          className="table table-bordered table-hover align-middle mb-0"
                          style={{
                            whiteSpace: "nowrap",
                            minWidth: `${420 + totalDays * 95}px`,
                          }}
                        >
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Name / Reg.no</th>

                              {Array.from({ length: totalDays }).map((_, i) => (
                                <th key={i}>{i + 1}</th>
                              ))}

                              <th className="bg-light text-success">Present</th>
                              <th className="bg-light text-danger">Absent</th>
                            </tr>
                          </thead>

                          <tbody>
                            {staffdata?.data?.map((item, index) => {
                              let totalPresent = 0;
                              let totalAbsent = 0;

                              // ✅ working days parse
                              let workingDays = [];
                              try {
                                workingDays = JSON.parse(
                                  item?.employment_info?.working_days || "[]",
                                );
                              } catch (e) {}

                              return (
                                <tr key={item?.id}>
                                  <td>{index + 1}</td>
                                  <td
                                    style={{
                                      left: "70px",
                                      background: "#fff",
                                      zIndex: 2,
                                      minWidth: "320px",
                                    }}
                                  >
                                    <div className="d-flex align-items-center">
                                      <div
                                        className="me-3"
                                        style={{
                                          width: 52,
                                          height: 52,
                                        }}
                                      >
                                        {item?.img ? (
                                          <img
                                            src={`${imgBaseUrl}${item.img}`}
                                            className="rounded-circle border shadow-sm"
                                            style={{
                                              width: "52px",
                                              height: "52px",
                                              objectFit: "cover",
                                            }}
                                          />
                                        ) : (
                                          <div
                                            className="rounded-circle bg-label-primary d-flex align-items-center justify-content-center fw-bold text-primary"
                                            style={{
                                              width: "52px",
                                              height: "52px",
                                              fontSize: "18px",
                                            }}
                                          >
                                            {item?.name
                                              ?.split(" ")
                                              ?.map((x) => x[0])
                                              ?.slice(0, 2)
                                              ?.join("")
                                              ?.toUpperCase()}
                                          </div>
                                        )}
                                      </div>

                                      <div>
                                        <div className="fw-semibold">
                                          {item.name}
                                        </div>

                                        <div className="small text-muted">
                                          {item.registration_no}

                                          <span className="mx-2">•</span>

                                          {item.staff_type}
                                        </div>

                                        <div className="small text-muted">
                                          <i className="ri-phone-line me-1"></i>

                                          {item.mobile}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  {Array.from({ length: totalDays }).map(
                                    (_, i) => {
                                      const day = String(i + 1).padStart(
                                        2,
                                        "0",
                                      );
                                      const currentDate = `${selectedMonth}-${day}`;

                                      const dayAttendances =
                                        item?.attendances?.filter(
                                          (att) => att.date === currentDate,
                                        ) || [];

                                      const checkDate = new Date(currentDate);
                                      const today = new Date();

                                      const isFuture = checkDate > today;

                                      const dayName = checkDate.toLocaleString(
                                        "en-US",
                                        {
                                          weekday: "short",
                                        },
                                      );

                                      const isWorkingDay =
                                        workingDays.includes(dayName);

                                      // FUTURE
                                      if (isFuture) return <td key={i}>-</td>;

                                      // 🔥 ATTENDANCE EXISTS
                                      if (dayAttendances.length > 0) {
                                        // ABSENT
                                        if (
                                          dayAttendances.some(
                                            (a) => a.is_leave === "1",
                                          )
                                        ) {
                                          totalAbsent++; // COUNT
                                          return (
                                            <td key={i}>
                                              <span className="badge rounded-pill bg-danger">
                                                A
                                              </span>
                                            </td>
                                          );
                                        }

                                        // PRESENT
                                        totalPresent++; //  COUNT

                                        return (
                                          <td
                                            key={i}
                                            className="text-success small"
                                          >
                                            {dayAttendances.map((a, idx) => (
                                              <div key={idx}>
                                                {a.check_in_time
                                                  ? "IN: " +
                                                    formatToTime(
                                                      a.check_in_time,
                                                    )
                                                  : ""}{" "}
                                                <br />
                                                {a.check_out_time
                                                  ? "  OUT: " +
                                                    formatToTime(
                                                      a.check_out_time,
                                                    )
                                                  : ""}
                                              </div>
                                            ))}
                                          </td>
                                        );
                                      }

                                      //  NOT WORKING
                                      if (!isWorkingDay) {
                                        if (dayName === "Sun") {
                                          return (
                                            <td key={i}>
                                              <span className="badge rounded-pill bg-primary">
                                                SUN
                                              </span>
                                            </td>
                                          );
                                        }

                                        return (
                                          <td key={i}>
                                            <span className="badge rounded-pill bg-warning text-dark">
                                              OFF
                                            </span>
                                          </td>
                                        );
                                      }

                                      // WORKING BUT NO ENTRY
                                      return <td key={i}>-</td>;
                                    },
                                  )}

                                  {/* TOTAL */}
                                  <td className="fw-bold text-success bg-success-subtle">
                                    {totalPresent}
                                  </td>
                                  <td className="fw-bold text-danger bg-danger-subtle">
                                    {totalAbsent}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
            <div className="content-backdrop fade"></div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
};

export default StaffMonthAttendance;
